goog.provide("shadow.js.shim.module$react_use$lib$component$UseKey$default");
shadow.js.shim.module$react_use$lib$component$UseKey$default = shadow.js.shim.module$react_use$lib$component$UseKey.default;
